/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class DropDownItem {
  id: number;
  itemName: string;

  constructor(id: number, itemName: string) {
    this.id = id;
    this.itemName = itemName;
  }

}
